import { Component, OnInit, ViewChild, ErrorHandler, OnDestroy, Input, NgZone } from '@angular/core';
import { AssureurService } from 'src/app/Services/Assureur/assureur.service';
import { IonicSelectableComponent } from 'ionic-selectable';
import { ToastController, AlertController, ActionSheetController,
   PopoverController, IonContent, ModalController, LoadingController, NavParams } from '@ionic/angular';
import { AlertInput } from '@ionic/core';
import { isUndefined } from 'util';


import { SharedService } from 'src/app/Services/sheared/sharedService.service';
import { authenticationService } from 'src/app/Services/Authentication/authentication.service';
// import { PrepareDocService } from 'src/app/Services/Cotation/PrepareDoc.service';
import { CotationSanteService } from 'src/app/Services/Cotation/cotationSante.service';
import { FactoryService } from 'src/app/Services/historique/factory.service';
import { PaiesimulateComponent } from 'src/app/Components/paiesimulate/paiesimulate.component';
import { Subscription } from 'rxjs';
import { PaiementService } from 'src/app/Services/Paiement/paiement.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-santeresumeprime',
  templateUrl: './santeresprime.component.html',
  styleUrls: ['./santeresprime.component.scss'],
})
export class SanteResPrimeComponent implements OnInit,OnDestroy {
  dtjr: string
  objetpass: any;
  itemsData: any[]
  private items: any[] = []
  select_Assureur: any = null;
  assureurs = [];
  selectedImage: string;
  fileList: string[] = []
  textImageselect: boolean
  isEnabled: boolean = false
  TypeObjet: string = ""
  afficheVoyage: boolean = false
  dta:any
  options = {
    centeredSlides: true,
    loop: false,
    spaceBetween: -50,
  };
  loading : HTMLIonLoadingElement
  @ViewChild(IonContent,{static:false}) content: IonContent
  constructor(private modalCtrl: ModalController, private assureurService: AssureurService,
    private _sheard: SharedService,
    private auth: authenticationService,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private _fact: FactoryService,
    private _cotationSanteService:CotationSanteService,
    private _primeService: PaiementService,
    private _route: Router, private ngZ: NgZone,
    private nvparms: NavParams) {
      this.objetpass = this.nvparms.get('value');
       
      this.objetpass.CodeAssur = this._fact.getData(201)
   
      this.objetpass.open=true
      this.dtjr = this._sheard.ConvertDMYorYMD(this._sheard.getDate());
      this.assureurService.getAssureurs();

  }
  onDetail(item) {

    item.open = !item.open;
  }
  ngOnDestroy(): void {

   
  }
  onValider(item) {
    //this.objetpass.cartegrise=this.selectedImage
    this.presentPayment(item)
  }
  ngOnInit(): void {
    this.TypeObjet = "SANTE"

    const timer=setTimeout(() =>{
      this.itemsData = this.objetpass
      clearTimeout(timer)
    },100)

   
    this.assureurService.ListAssreurs.subscribe(res => {
      try {
        this.assureurs = res
        // if (isUndefined(this.objetpass.CodeAssur)) {
        //   this.assureurs = res
        // }else
        // {
        //   this.assureurs = res.filter(a => (a.CodeAssu === this.objetpass.CodeAssur))
        // }
      } catch (error) {
        
      }
    })
  }

  PayerPrimer() {


    this.controlDeProvenance(this.TypeObjet)
 
   }
  private async presentPayment(nameSelected) {

    let dateEffet = this._sheard.getDateWithTimeDMY()
    let jrs
    let dateExpi


      dateEffet = this._sheard.ConvertDMYorYMD(nameSelected.dateEf)
      dateExpi = `31-12-${new Date().getFullYear()}`
      jrs = 1 + 1 * this._sheard.diffDays(nameSelected.dateEf, `${new Date().getFullYear()}-12-31`)
      nameSelected.periode = jrs + " jours"
    

    const alert = await this.alertController.create({
      header: 'Paiement de la prime',mode:"ios",
      message: 'Vous avez choisi une couverture d\'une durée de <strong>' + nameSelected.periode +
        '</strong>. Ce contrat d\'assurance prendra donc effet à :' +
        '<p>*Date éffet <strong>' + dateEffet + '</strong></p>' +
        '<p>*Date expiration <strong>' + dateExpi + '</strong></p>' +
        '<p><strong>NB:</strong> Si vous reportez le paiement de la prime à un autre jour,' +
        'la date d\'effet sera la date de paiement </p><br>',

      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
          cssClass: 'primary',
          handler: () => {
            //this._objet = "Selectionner l'objet"

          }
        },
        {
          text: 'OK',
          handler: () => {
            this.objetpass = this.itemsData
            this.textImageselect = true

            this.objetpass.dateEffet = dateEffet;
            this.objetpass.dateExpi = dateExpi;
            this.objetpass.duree =  jrs 


            setTimeout(() => {
              this.content.scrollToBottom(800).then(
                //() => this.affiche=true
              )
              // $("#mytext").focus();
            });



          }
        }
      ]
    });
    await alert.present();
  }
  private desactiveBtn() {
    this.isEnabled = false;
    if (this.objetpass.CodeAssur) {
      this.isEnabled = true;
    }


  }
  userChange(event: { component: IonicSelectableComponent, value: any }) {

    if (event.value) {
      this.objetpass.CodeAssur = event.value.CodeAssu
      this.desactiveBtn()
    } else {

    }

  }
  private uploadingSante($key: string,police) {
    let Id_sante = this._fact.getData(150)
    let sante = {
      dateInsert: this._sheard.getTimeStampFromToday(),
      adulte: Id_sante.adulte,
      enfant: Id_sante.enfant,
      typeformule0: Id_sante.forml0,
      typeformule1: Id_sante.forml1,
      response: "",
      Police:police,
      observateur: Id_sante.messageText,
      // icon:"medkit"
      icon: "../../../assets/img/sante.png",
      Assistance: (this.objetpass.length > 1) ? this.objetpass[1] : "",
    }
    this._cotationSanteService.instNewSante(sante, this.objetpass.CodeAssur, $key)
      .then
      (
        () => {

          this.loading.dismiss().then(
            (res) => {
              if (res) {
                this.modalCtrl.dismiss().then(
                  (res) => {
                    if (res) {

                      this._route.navigate(['prime/', 30]);
                    }
                  }
                )
              }
            }
          )
        })
  }
  async controlDeProvenance(provenance: string, _objet: any = null) {
    this.loading = await this.loadingController.create({
      message: 'Envoi en cours...',
      duration: 30000,
      mode:"ios",
      spinner: 'bubbles'
    });
    this.loading.present()
    this._fact.setData(30, [])
let Ttc=(this.objetpass.length > 1) ? (1 * this.objetpass[0].Ttc + this.objetpass[1].Ttc * 1) : 1 * this.objetpass[0].Ttc
      //#region  SANTE   
      this.objetpass.CodeAssur = this._fact.getData(201)  
      let police=`SANT-${this._sheard.generatorPolice()}`
        this.items = []
        this.items.push({
          NumPolice: police,
          police:police,
          NomPrenom: this.auth.profile.NomPrenom,
          Notification: "",
          CodeAssur: this.objetpass.CodeAssur,
          NumRef: "",
          dateEffet: this.objetpass.dateEffet,
          dateExpi: this.objetpass.dateExpi,
          montant_due: Ttc,
          montant_paye: 0,
          date_paiement: "",
          dateInsert: this._sheard.getDate(),
          etatdoc: "",
          icon: "../../../assets/icon/fitness.svg",
          flag: false,
          CodeMvt: "AFN",
          //isChecked:true,
          notifydoc: false,
          notify: true,
          duree: this.objetpass.duree,
          mode_paie: "",
          numClient:"", //this.auth.profile.numClient,
          solde: false,
          type: "Sante",
          idKey: this.auth.profile.uid
        })
        this._primeService.insertPrime(this.items).then(
          (res) => {
            this.items[0].$key = res.key
            this.items[0].nbPaie=0
            this.items[0].montantVerse=0
            this.items[0].montant_restant=Ttc
            this._fact.setData(30, this.items[0])
            if (provenance == "SANTE") {
              this.uploadingSante(res.key,police)
              // if (isUndefined(this.objetpass.CodeAssur)) {
              //       this._primeService.addQuit(res.key,this.objetpass.CodeAssur)
              // }
            }

          }
        )

      //#endregion

     
  }

}
